import type { businessEn } from '@/i18n/resources/business-en.ts';

export const businessNb = {
  'business.common.accessibility': 'Tilgjengelighet',
  'business.common.active': 'Aktiv',
  'business.common.business': 'Virksomhet',
  'business.common.continue': 'Fortsett',
  'business.common.delete': 'Slett',
  'business.common.description': 'Beskrivelse',
  'business.common.directions': 'Veibeskrivelse',
  'business.common.edit': 'Rediger',
  'business.common.eventCount': 'ingen arrangementer | arrangement | arrangementer',
  'business.common.introduction': 'Introduksjon',
  'business.common.name': 'Navn',
  'business.common.next': 'Neste',
  'business.common.pageOf': 'Side {page} av {total}',
  'business.common.paused': 'Satt på pause',
  'business.common.previous': 'Forrige',
  'business.common.remove': 'Fjern',
  'business.common.type': 'Type',
  'business.common.verified': 'Verifisert',
  'business.category.label': 'Virksomhetskategori',
  'business.category.select': 'Velg en kategori',
  'business.category.help': 'Velg kategorien som beskriver virksomheten best.',
  'business.discovery.storefrontAlt': 'Fasaden til {name}',
  'business.discovery.fallbackDescription': 'Oppdag denne lokale virksomheten.',
  'business.discovery.booking': 'Bestilling',
  'business.discovery.accessibilityAvailable': 'Tilgjengelighetsinformasjon finnes',
  'business.discovery.loading': 'Laster virksomhet',
  'business.discovery.localityUnavailable': 'Sted er ikke oppgitt',
  'business.discovery.openNow': 'Åpent nå',
  'business.discovery.closed': 'Stengt',
  'business.follow.savedToast': '{name} er lagret. Arrangementsvarsler er på.',
  'business.follow.followError': 'Kunne ikke følge virksomheten.',
  'business.follow.removedToast': '{name} er fjernet fra lagrede virksomheter.',
  'business.follow.unfollowError': 'Kunne ikke slutte å følge virksomheten.',
  'business.follow.preferenceError': 'Kunne ikke oppdatere varselet.',
  'business.follow.save': 'Lagre og følg',
  'business.follow.saved': 'Lagret',
  'business.follow.preferencesAria': 'Innstillinger for virksomhetsvarsler',
  'business.follow.alertsFrom': 'Varsler fra {name}',
  'business.follow.alertPrivacy': 'Varsler i appen er alltid private. E-post og nettvarsler følger de globale innstillingene dine.',
  'business.follow.newEvents': 'Nye arrangementer',
  'business.follow.newSessions': 'Nye økter',
  'business.follow.availability': 'Plasser blir ledige',
  'business.attachments.previewAlt': 'Forhåndsvisning av vedlegg: {filename}',
  'business.attachments.attachmentNumber': 'Vedlegg {number}',
  'business.attachments.downloadFailed': 'Nedlasting av vedlegget mislyktes.',
  'business.attachments.downloadError': 'Vedlegget kunne ikke lastes ned.',
  'business.photos.viewerAria': 'Bildevisning for {name}',
  'business.photos.position': 'Bilde {current} av {total}',
  'business.photos.close': 'Lukk bildevisningen',
  'business.photos.previous': 'Forrige bilde',
  'business.photos.next': 'Neste bilde',
  'business.checklist.identity': 'Identitet',
  'business.checklist.identityDescription': 'Navn, brukernavn, kategori og verifisering',
  'business.checklist.imagery': 'Bilder',
  'business.checklist.imageryDescription': 'Logo og minst ett virksomhetsbilde',
  'business.checklist.description': 'Beskrivelse',
  'business.checklist.descriptionDescription': 'En nyttig offentlig introduksjon',
  'business.checklist.openingHours': 'Åpningstider',
  'business.checklist.openingHoursDescription': 'Vanlige eller avvikende åpningstider',
  'business.checklist.location': 'Sted',
  'business.checklist.locationDescription': 'Offentlig adresse og kartposisjon',
  'business.checklist.accessibilityDescription': 'Praktisk tilgjengelighetsinformasjon',
  'business.checklist.communityPosts': 'Fellesskapsinnlegg',
  'business.checklist.communityPostsDescription': 'Minst én publisert oppdatering',
  'business.checklist.events': 'Arrangementer',
  'business.checklist.eventsDescription': 'Minst ett arrangement i programmet',
  'business.checklist.title': 'Profilens fullstendighet',
  'business.checklist.help': 'Hjelp besøkende med å forstå virksomheten og velge hva de vil gjøre.',
  'business.checklist.completeCount': '{completed} av {total} fullført',
  'business.checklist.progressAria': 'Virksomhetsprofilen er {progress}% fullført',
  'business.report.title': 'Rapporter {type}',
  'business.report.typePost': 'innlegg',
  'business.report.typeComment': 'kommentar',
  'business.report.body': 'Forklar kort hvorfor innholdet bør gjennomgås.',
  'business.report.reason': 'Årsak til rapportering',
  'business.report.submit': 'Send rapport',
  'business.report.success': 'Takk. Innholdet er rapportert.',
  'business.report.error': 'Rapporten kunne ikke sendes.',
  'business.report.action': 'Rapporter',
  'business.booking.beforeYouBook': 'Før du bestiller',
  'business.booking.verifiedBusiness': 'Dette er en verifisert Vennevent-virksomhet.',
  'business.booking.verificationUnavailable': 'Virksomhetsverifisering er ikke tilgjengelig.',
  'business.booking.askAccessibility': 'Spør virksomheten om tilrettelegging før du bestiller.',
  'business.booking.paymentSafety': 'Pris og betalingskrav vises før bekreftelse. Vennevent lagrer ikke betalingsopplysningene dine.',
  'business.booking.cancellationVaries': 'Avbestillingsvilkår kan variere mellom ressurser og vises nedenfor når de er oppgitt.',
  'business.booking.messageBusiness': 'Send melding til virksomheten',
  'business.booking.supportDetails': 'Vis kontaktinformasjon for hjelp',
  'business.booking.website': 'Virksomhetens nettsted',
  'business.booking.cancellation': 'Avbestilling:',
  'business.subscription.awaitingApproval': 'Den eksisterende Vipps-avtalen venter fortsatt på godkjenning.',
  'business.subscription.checkoutError': 'Kunne ikke starte abonnementsbetalingen.',
  'business.subscription.redirectError': 'Den sikre betalingssiden for abonnementet kunne ikke åpnes. Ingen planendring er bekreftet.',
  'business.subscription.cancelTitle': 'Avslutte Pro-abonnementet?',
  'business.subscription.cancelBody':
    'Pro er tilgjengelig ut den betalte perioden eller prøveperioden. Eksisterende bestillinger, fakturaer og kundeforpliktelser forblir tilgjengelige.',
  'business.subscription.scheduleCancellation': 'Planlegg avslutning',
  'business.subscription.keepPro': 'Behold Pro',
  'business.subscription.cancellationScheduled': 'Avslutning er planlagt.',
  'business.subscription.cancelError': 'Kunne ikke avslutte abonnementet.',
  'business.subscription.title': 'Abonnement og fakturering',
  'business.subscription.paymentInfo': 'Vipps MobilePay administrerer betalingsavtalen. Prisene inkluderer 25 % norsk merverdiavgift.',
  'business.subscription.loading': 'Laster faktureringsinformasjon',
  'business.subscription.unavailable': 'Faktureringsinformasjonen er midlertidig utilgjengelig. Abonnementet er ikke endret.',
  'business.subscription.trialEnds': 'Prøveperioden slutter {date}.',
  'business.subscription.paymentAttention': 'Betalingen må følges opp i Vipps. Pro er tilgjengelig til {date}.',
  'business.subscription.actionsPaused': 'Pro-handlinger er satt på pause. Eksisterende bestillinger og fakturaer er fortsatt tilgjengelige.',
  'business.subscription.proEnds': 'Pro avsluttes {date}. Eksisterende kundedata skjules ikke.',
  'business.subscription.periodEnds': 'Gjeldende periode slutter {date}.',
  'business.subscription.cancelPlan': 'Avslutt abonnement',
  'business.subscription.annual': 'årlig',
  'business.subscription.monthly': 'månedlig',
  'business.subscription.trialDescription': '{days} dagers gratis prøveperiode, deretter automatisk fornyelse. Avslutt når som helst.',
  'business.subscription.featurePayments': 'Vipps-betalinger og ressursbestilling',
  'business.subscription.featureAnalytics': 'Overordnede arrangementer og forbedret aggregert analyse',
  'business.subscription.featureLimits': 'Høyere driftsgrenser',
  'business.subscription.startTrial': 'Start gratis prøveperiode',
  'business.subscription.invoices': 'Fakturaer',
  'business.subscription.invoice': 'Faktura',
  'business.subscription.date': 'Dato',
  'business.subscription.total': 'Totalt',
  'business.subscription.vatIncluded': 'Mva. inkludert',
  'business.subscription.status': 'Status',
  'business.subscription.statusTrialing': 'Prøveperiode',
  'business.subscription.statusActive': 'Aktiv',
  'business.subscription.statusGrace': 'Betalingsfrist',
  'business.subscription.statusPastDue': 'Forfalt',
  'business.subscription.statusCancelScheduled': 'Avslutning planlagt',
  'business.subscription.statusCanceled': 'Avsluttet',
  'business.subscription.statusExpired': 'Utløpt',
  'business.resources.embedTitle': 'Bestill hos oss',
  'business.resources.created': 'Ressursen er opprettet.',
  'business.resources.createError': 'Kunne ikke opprette ressursen.',
  'business.resources.settingsSaved': 'Innstillingene for bestillingssiden er lagret.',
  'business.resources.settingsError': 'Kunne ikke lagre bestillingssiden.',
  'business.resources.title': 'Ressurser som kan bestilles',
  'business.resources.intro': 'Administrer rom, baner, bord, utstyr eller instruktørtid.',
  'business.resources.customerView': 'Kundevisning',
  'business.resources.capacityValue': 'kapasitet {capacity}',
  'business.resources.empty': 'Ingen ressurser ennå.',
  'business.resources.add': 'Legg til ressurs',
  'business.resources.minimumDuration': 'Minste varighet (minutter)',
  'business.resources.maximumDuration': 'Maksimal varighet (minutter)',
  'business.resources.bookingStep': 'Bestillingsintervall (minutter)',
  'business.resources.pricePerStep': 'Pris per intervall (øre)',
  'business.resources.cancellationTerms': 'Avbestillingsvilkår',
  'business.resources.exclusive': 'Eksklusiv (én bestilling om gangen)',
  'business.resources.create': 'Opprett ressurs',
  'business.resources.publicPageTitle': 'Offentlig bestillingsside og nettstedsmodul',
  'business.resources.publicPageIntro':
    'Tilpass siden som driftes av Vennevent. Bestilling, innlogging, kapasitetskontroll og betaling fortsetter alltid sikkert hos Vennevent.',
  'business.resources.accentColour': 'Aksentfarge',
  'business.resources.defaultLanguage': 'Standardspråk',
  'business.resources.allowedWebsites': 'Nettsteder som kan bygge inn modulen',
  'business.resources.originPlaceholder': 'https://www.eksempel.no',
  'business.resources.originsHelp': 'Oppgi nøyaktige HTTPS-opprinnelser, adskilt med mellomrom eller komma. Stier og jokertegn støttes ikke.',
  'business.resources.publicEnabled': 'Offentlig side aktivert',
  'business.resources.showAddress': 'Vis adresse',
  'business.resources.showBranding': 'Vis Vennevent-profilering',
  'business.resources.analytics': 'Grove, samtykkebaserte henvisningstall',
  'business.resources.savePage': 'Lagre bestillingsside',
  'business.resources.embedCode': 'Innbyggingskode',
  'business.resources.embedCodeAria': 'Innbyggingskode for nettsted',
  'business.resources.previewPage': 'Forhåndsvis offentlig side',
  'business.resources.previewWidget': 'Forhåndsvis modul',
  'business.resources.kindRoom': 'Rom',
  'business.resources.kindCourt': 'Bane',
  'business.resources.kindTable': 'Bord',
  'business.resources.kindEquipment': 'Utstyr',
  'business.resources.kindInstructor': 'Instruktør',
  'business.resources.kindOther': 'Annet',
  'business.community.settingsSaved': 'Fellesskapsinnstillingene er lagret.',
  'business.community.settingsError': 'Innstillingene kunne ikke lagres.',
  'business.community.postPublished': 'Fellesskapsinnlegget er publisert.',
  'business.community.publishError': 'Innlegget kunne ikke publiseres.',
  'business.community.imageError': 'Ett av bildene kunne ikke behandles.',
  'business.community.postUpdated': 'Innlegget er oppdatert.',
  'business.community.updateError': 'Innlegget kunne ikke oppdateres.',
  'business.community.deletePostTitle': 'Slette innlegget?',
  'business.community.deletePostBody': 'Innlegget og alle kommentarene slettes permanent.',
  'business.community.postDeleted': 'Innlegget er slettet.',
  'business.community.deleteError': 'Innlegget kunne ikke slettes.',
  'business.community.conversationLoadError': 'Samtalen kunne ikke lastes.',
  'business.community.replyError': 'Svaret kunne ikke sendes.',
  'business.community.messageError': 'Meldingen kunne ikke sendes.',
  'business.community.conversationUpdateError': 'Samtalen kunne ikke oppdateres.',
  'business.community.title': 'Fellesskap',
  'business.community.intro': 'Del oppdateringer på den offentlige virksomhetsprofilen.',
  'business.community.writeUpdate': 'Skriv en oppdatering …',
  'business.community.postAria': 'Fellesskapsinnlegg',
  'business.community.postImages': 'Innleggsbilder',
  'business.community.publish': 'Publiser',
  'business.community.directoryAndChat': 'Katalog og chat',
  'business.community.showDirectory': 'Vis i fellesskapskatalogen',
  'business.community.showDirectoryHelp': 'La folk oppdage virksomheten.',
  'business.community.allowMessages': 'Tillat meldinger',
  'business.community.allowMessagesHelp': 'Vis «Send melding» på den offentlige profilen.',
  'business.community.saveSettings': 'Lagre innstillinger',
  'business.community.publishedPosts': 'Publiserte innlegg',
  'business.community.loadingPosts': 'Laster innlegg …',
  'business.community.noPosts': 'Ingen innlegg er publisert ennå.',
  'business.community.publishing': 'Publiserer …',
  'business.community.editPost': 'Rediger innlegg',
  'business.community.postOptions': 'Innleggsvalg',
  'business.community.postImageAlt': 'Bilde i virksomhetsinnlegg',
  'business.community.commentCount': 'ingen kommentarer | én kommentar | {count} kommentarer',
  'business.community.postPages': 'Sider med publiserte innlegg',
  'business.community.sharedInbox': 'Delt innboks',
  'business.community.inboxPrivacy': 'Meldinger er synlige for autoriserte medarbeidere.',
  'business.community.loadingConversations': 'Laster samtaler …',
  'business.community.noMessages': 'Ingen kundemeldinger ennå.',
  'business.community.customerId': 'Kunde {id}',
  'business.community.updatedAt': 'Oppdatert {date}',
  'business.community.unreadCount': 'ingen uleste meldinger | én ulest melding | {count} uleste meldinger',
  'business.community.conversationWith': 'Samtale med {id}',
  'business.community.reopen': 'Åpne igjen',
  'business.community.close': 'Lukk',
  'business.community.block': 'Blokker',
  'business.community.retention': 'Samtaler utløper etter 12 måneder uten aktivitet. Begge parter varsles 30 dager før sletting.',
  'business.community.removalWarning': 'Denne inaktive samtalen skal slettes med mindre noen svarer.',
  'business.community.customer': 'Kunde',
  'business.community.yourBusiness': 'Din virksomhet',
  'business.community.read': 'Lest',
  'business.community.delivered': 'Levert',
  'business.community.replyPlaceholder': 'Svar som virksomheten',
  'business.community.replyAttachments': 'Svarvedlegg',
  'business.community.sendReply': 'Send svar',
  'business.community.reportPrompt': 'Hva bør modereringsteamet vite?',
  'business.community.conversationReported': 'Samtalen er rapportert for gjennomgang.',
  'business.community.reportConversationError': 'Samtalen kunne ikke rapporteres.',
  'business.community.statusOpen': 'Åpen',
  'business.community.statusClosed': 'Lukket',
  'business.community.statusBlocked': 'Blokkert',
  'business.comments.imageError': 'Bildet kunne ikke behandles.',
  'business.comments.updated': 'Kommentaren er oppdatert.',
  'business.comments.updateError': 'Kommentaren kunne ikke oppdateres.',
  'business.comments.deleteTitle': 'Slette kommentaren?',
  'business.comments.deleteBody': 'Kommentaren slettes permanent.',
  'business.comments.deleted': 'Kommentaren er slettet.',
  'business.comments.deleteError': 'Kommentaren kunne ikke slettes.',
  'business.comments.signInRequired': 'Du må være innlogget før du kan kommentere.',
  'business.comments.publishError': 'Kommentaren kunne ikke publiseres.',
  'business.comments.title': 'Kommentarer',
  'business.comments.loadError': 'Kommentarene kunne ikke lastes.',
  'business.comments.avatarAlt': 'Profilbilde for {name}',
  'business.comments.imageAlt': 'Kommentarbilde',
  'business.comments.edit': 'Rediger kommentar',
  'business.comments.options': 'Kommentarvalg',
  'business.comments.empty': 'Ingen kommentarer på innlegget ennå.',
  'business.comments.imageToAdd': 'Bilde som skal legges til',
  'business.comments.removeImage': 'Fjern bilde',
  'business.comments.placeholder': 'Skriv kommentaren din …',
  'business.comments.send': 'Send kommentar',
  'business.comments.addImage': 'Legg til bilde',
  'business.comments.signIn': 'Logg inn med en personlig konto for å kommentere.',
  'business.finance.periodError': 'Periodestarten må være før slutten.',
  'business.finance.exported': 'Regnskapseksporten er lastet ned.',
  'business.finance.exportError': 'Kunne ikke eksportere regnskapsperioden.',
  'business.finance.resolutionRequired': 'Legg til et løsningsnotat før avviket lukkes.',
  'business.finance.exceptionResolved': 'Avstemmingsavviket er løst og revidert.',
  'business.finance.resolveError': 'Kunne ikke løse avviket.',
  'business.finance.accessGranted': 'Finanstilgang er gitt. Brukeren må allerede være godkjent medarbeider.',
  'business.finance.grantError': 'Kunne ikke gi finanstilgang.',
  'business.finance.refundTitle': 'Refunder {title}',
  'business.finance.denyTitle': 'Avslå refusjonsforespørsel',
  'business.finance.refundAmountHelp': 'Oppgi refusjonsbeløpet i {currency}. Maksimalt: {maximum}.',
  'business.finance.decisionNote': 'Beslutningsnotat',
  'business.finance.denyRequest': 'Avslå forespørsel',
  'business.finance.auditReason': 'Begrunnelse for økonomisk revisjon',
  'business.finance.approvalReason': 'Begrunnelse for å godkjenne refusjonen',
  'business.finance.cancelAttendanceTitle': 'Også avbestille deltakelsen?',
  'business.finance.cancelAttendanceBody': 'Refusjon og avbestilling av deltakelse er separate. Deltakelsen endres først etter at Vipps bekrefter refusjonen.',
  'business.finance.refundAndCancel': 'Refunder og avbestill',
  'business.finance.refundOnly': 'Bare refunder',
  'business.finance.refundSubmitted': 'Refusjonen er sendt til Vipps.',
  'business.finance.refundDenied': 'Refusjonsforespørselen er avslått.',
  'business.finance.reviewError': 'Kunne ikke behandle refusjonsforespørselen.',
  'business.finance.title': 'Økonomi og avstemming',
  'business.finance.intro':
    'Reproduserbare UTC-regnskapsperioder fra betalingsleverandørens autoritative data. Kundenavn og betalingsopplysninger tas aldri med.',
  'business.finance.loading': 'Laster økonomiarbeidsområdet',
  'business.finance.accessRequired': 'Økonomidata krever en separat finanstillatelse. Vanlig medarbeidertilgang er ikke tilstrekkelig.',
  'business.finance.accountingPeriod': 'Regnskapsperiode',
  'business.finance.fromUtc': 'Fra (UTC)',
  'business.finance.throughUtc': 'Til og med (UTC)',
  'business.finance.applyPeriod': 'Bruk periode',
  'business.finance.exportCsv': 'Eksporter CSV',
  'business.finance.charges': 'Belastninger',
  'business.finance.refundsFees': 'Refusjoner og gebyrer',
  'business.finance.settlements': 'Oppgjørsposter',
  'business.finance.ledgerNet': 'Netto hovedbok',
  'business.finance.noActivity': 'Det finnes ingen hovedbokaktivitet i perioden.',
  'business.finance.exceptions': 'Avstemmingsavvik',
  'business.finance.reference': 'Referanse',
  'business.finance.notSupplied': 'ikke oppgitt',
  'business.finance.expected': 'forventet',
  'business.finance.ledger': 'hovedbok',
  'business.finance.detected': 'Oppdaget {date}',
  'business.finance.resolutionNote': 'Løsningsnotat',
  'business.finance.resolutionPlaceholder': 'Forklar hvordan avviket ble kontrollert',
  'business.finance.resolve': 'Løs',
  'business.finance.review': 'Gjennomgå',
  'business.finance.refundRequests': 'Refusjonsforespørsler fra deltakere',
  'business.finance.approveRefund': 'Godkjenn refusjon',
  'business.finance.deny': 'Avslå',
  'business.finance.ledgerEntries': 'Hovedboksposter',
  'business.finance.timeUtc': 'Tid (UTC)',
  'business.finance.source': 'Kilde',
  'business.finance.amount': 'Beløp',
  'business.finance.grantTitle': 'Gi separat finanstilgang',
  'business.finance.grantHelp': 'Brukeren må allerede være godkjent medarbeider. Virksomhetsroller gir aldri implisitt finanstilgang.',
  'business.finance.staffUserId': 'Bruker-ID for godkjent medarbeider',
  'business.finance.role': 'Finansrolle',
  'business.finance.roleViewer': 'Vis',
  'business.finance.roleExporter': 'Vis og eksporter',
  'business.finance.roleAdministrator': 'Finansadministrator',
  'business.finance.grantAccess': 'Gi tilgang',
  'business.finance.entryCharge': 'Belastning',
  'business.finance.entryRefund': 'Refusjon',
  'business.finance.entryFee': 'Gebyr',
  'business.finance.entrySettlement': 'Oppgjør',
  'business.finance.entryCorrection': 'Korrigering',
  'business.finance.sourceEvent': 'Arrangement',
  'business.finance.sourceResource': 'Ressurs',
  'business.finance.sourceSubscription': 'Abonnement',
  'business.finance.sourceProvider': 'Leverandør',
  'business.operations.unknownResource': 'Ukjent ressurs',
  'business.operations.acceptedStaff': 'Godkjent medarbeider',
  'business.operations.refreshed': 'Driftsoversikten er oppdatert. Kontroller de beholdte verdiene før du sender inn igjen.',
  'business.operations.invalidInstants': 'Oppgi begge tidene som nøyaktige ISO-tidspunkter med Z eller numerisk UTC-forskyvning.',
  'business.operations.endAfterStart': 'Sluttidspunktet må være etter starttidspunktet.',
  'business.operations.updateError': 'Kunne ikke oppdatere driften.',
  'business.operations.rescheduled': 'Bestillingen er flyttet. Kundevarselet sendes etter at endringen er lagret.',
  'business.operations.rescheduleError': 'Kunne ikke flytte bestillingen.',
  'business.operations.maintenanceCreated': 'Vedlikeholdsblokken er opprettet og revidert.',
  'business.operations.maintenanceUpdated': 'Vedlikeholdsblokken er oppdatert og revidert.',
  'business.operations.maintenanceSaveError': 'Kunne ikke lagre vedlikeholdsblokken.',
  'business.operations.maintenanceCancelled': 'Vedlikeholdsblokken er avbrutt. Revisjonshistorikken beholdes.',
  'business.operations.maintenanceCancelError': 'Kunne ikke avbryte vedlikeholdsblokken.',
  'business.operations.assignmentAdded': 'Medarbeidertildelingen er lagt til og revidert.',
  'business.operations.assignmentAddError': 'Kunne ikke legge til tildelingen.',
  'business.operations.assignmentRemoved': 'Medarbeidertildelingen er fjernet og revidert.',
  'business.operations.assignmentRemoveError': 'Kunne ikke fjerne tildelingen.',
  'business.operations.noteSaved': 'Det private driftsnotatet er lagret og revidert.',
  'business.operations.noteSaveError': 'Kunne ikke lagre driftsnotatet.',
  'business.operations.title': 'Ressursdrift',
  'business.operations.intro':
    'Bestillinger, forberedelsesbuffere, vedlikehold, kapasitet og medarbeidere i hver ressurs sin tidssone. Alle endringer bruker skjemaer – draing er aldri nødvendig.',
  'business.operations.refresh': 'Oppdater drift',
  'business.operations.loading': 'Laster ressursdrift',
  'business.operations.unavailable': 'Ressursdriften er utilgjengelig, eller medarbeiderrollen din mangler tilgang.',
  'business.operations.day': 'Dag',
  'business.operations.week': 'Uke',
  'business.operations.previousView': 'Forrige {view}',
  'business.operations.nextView': 'Neste {view}',
  'business.operations.calendarDate': 'Kalenderdato',
  'business.operations.addMaintenance': 'Legg til vedlikehold',
  'business.operations.timezoneHelp': 'Datoer brukes separat i hver oppførte IANA-tidssone. Tidene viser UTC-forskyvningen, også ved sommertidsendringer.',
  'business.operations.scheduleChanged': 'Tidsplanen er endret siden du åpnet den',
  'business.operations.scheduleConflict': 'Konflikt i tidsplanen',
  'business.operations.conflictPrivacy': 'Ingen kundeopplysninger vises. Verdiene du skrev inn er beholdt.',
  'business.operations.conflictRefreshed': 'Gjeldende tidsplan er lastet. Kontroller konflikten og send bare inn igjen hvis intervallet fortsatt passer.',
  'business.operations.createResourceFirst': 'Opprett en bestillbar ressurs før du bruker driftskalenderen.',
  'business.operations.calendarAria': 'Driftskalender for {view}',
  'business.operations.resource': 'Ressurs',
  'business.operations.capacity': 'Kapasitet {capacity}',
  'business.operations.exclusive': 'eksklusiv',
  'business.operations.buffers': 'Buffere {before} min før / {after} min etter',
  'business.operations.cellAria': '{resource}, {date}, {count} driftsoppføringer',
  'business.operations.openDetailsAria': '{title}, {interval}, åpne detaljer',
  'business.operations.quantity': 'Antall {quantity} / {capacity}',
  'business.operations.assignedCount': 'ingen tildelt | én tildelt | {count} tildelt',
  'business.operations.addMaintenanceAria': 'Legg til vedlikehold for {resource}; skjemaet åpnes tomt',
  'business.operations.maintenance': 'Vedlikehold',
  'business.operations.noOperations': 'Ingen drift',
  'business.operations.agenda': 'Kronologisk agenda',
  'business.operations.emptyPeriod': 'Ingen bestillings-, buffer- eller vedlikeholdsoppføringer i perioden.',
  'business.operations.newMaintenance': 'Ny vedlikeholdsblokk',
  'business.operations.isoHelpBefore': 'Nøyaktige ISO-tidspunkter inneholder',
  'business.operations.isoHelpAfter': 'eller en eksplisitt UTC-forskyvning. Dette unngår tvetydige eller ugyldige tider ved sommertid.',
  'business.operations.closeEditor': 'Lukk driftsredigeringen',
  'business.operations.bufferHelp': 'Denne beskyttede bufferen følger bestillingen. Flytt bestillingen for å flytte bufferen.',
  'business.operations.rescheduleAria': 'Flytt bestilling uten draing',
  'business.operations.rescheduleBooking': 'Flytt bestilling',
  'business.operations.startInstant': 'Start · Nøyaktig ISO-tidspunkt',
  'business.operations.endInstant': 'Slutt · Nøyaktig ISO-tidspunkt',
  'business.operations.rescheduleHelp':
    'Ressurs, varighet, antall, pris, betalingsstatus og kunde beholdes. Endre dette gjennom avbestilling/refusjon og en ny bestilling.',
  'business.operations.checkAndReschedule': 'Kontroller tilgjengelighet og flytt',
  'business.operations.createMaintenanceAria': 'Opprett vedlikehold uten draing',
  'business.operations.editMaintenanceAria': 'Rediger vedlikehold uten draing',
  'business.operations.createMaintenance': 'Opprett vedlikehold / sperring',
  'business.operations.editMaintenance': 'Rediger vedlikehold / sperring',
  'business.operations.publicSummary': 'Offentlig sammendrag',
  'business.operations.privateNoteOptional': 'Privat driftsnotat (valgfritt)',
  'business.operations.privateNoteHelp': 'Bare autoriserte driftsmedarbeidere; vises aldri til kunder eller i moduler.',
  'business.operations.checkAndCreate': 'Kontroller konflikter og opprett',
  'business.operations.checkAndSave': 'Kontroller konflikter og lagre',
  'business.operations.cancelMaintenance': 'Avbryt vedlikehold',
  'business.operations.staffAssignments': 'Medarbeidertildelinger',
  'business.operations.removeAssignmentAria': 'Fjern tildelingen til {name}',
  'business.operations.noStaff': 'Ingen medarbeidere er tildelt.',
  'business.operations.assignStaffAria': 'Tildel medarbeider uten draing',
  'business.operations.roleLabel': 'Etikett for driftsrolle',
  'business.operations.rolePlaceholder': 'Åpningsansvarlig',
  'business.operations.assign': 'Tildel',
  'business.operations.editPrivateNoteAria': 'Rediger privat driftsnotat',
  'business.operations.privateNote': 'Privat driftsnotat',
  'business.operations.privateNoteVisibility': 'Bare synlig for autoriserte driftsmedarbeidere og utelatt fra kundevarsler, eksporter og moduler.',
  'business.operations.savePrivateNote': 'Lagre privat notat',
  'business.profile.metadataDescription': 'Les om {name} på Vennevent.',
  'business.profile.photoAlt': 'Bilde {number} av {name}',
  'business.profile.shareText': 'Oppdag {name} på Vennevent',
  'business.profile.shared': 'Virksomheten er delt.',
  'business.profile.linkCopied': 'Lenken er kopiert til utklippstavlen.',
  'business.profile.shareError': 'Kunne ikke dele virksomheten. Prøv igjen.',
  'business.profile.loading': 'Laster virksomhetsprofil',
  'business.profile.unavailable': 'Virksomhetsprofilen er utilgjengelig.',
  'business.profile.logoAlt': 'Logoen til {name}',
  'business.profile.addressMissing': 'Adresse er ikke oppgitt',
  'business.profile.approximately': 'Omtrent {distance}',
  'business.profile.editBusiness': 'Rediger virksomhet',
  'business.profile.actions': 'Virksomhetshandlinger',
  'business.profile.book': 'Bestill',
  'business.profile.message': 'Send melding',
  'business.profile.upcomingEventCount': 'ingen kommende arrangementer | ett kommende arrangement | {count} kommende arrangementer',
  'business.profile.call': 'Ring',
  'business.profile.share': 'Del',
  'business.profile.sections': 'Deler av virksomhetsprofilen',
  'business.profile.about': 'Om',
  'business.profile.posts': 'Innlegg',
  'business.profile.events': 'Arrangementer',
  'business.profile.booking': 'Bestilling',
  'business.profile.chat': 'Chat',
  'business.profile.postCount': 'ingen innlegg | ett innlegg | {count} innlegg',
  'business.profile.bookingAvailable': 'Bestilling tilgjengelig',
  'business.profile.chatAvailable': 'Chat tilgjengelig',
  'business.profile.introductionMissing': 'Virksomheten har ikke lagt til en introduksjon ennå.',
  'business.profile.contact': 'Kontakt',
  'business.profile.contactMissing': 'Kontaktinformasjon er ikke oppgitt.',
  'business.profile.hoursMissing': 'Åpningstider er ikke oppgitt.',
  'business.profile.exceptionalHours': 'Avvikende åpningstider',
  'business.profile.accessibilityMissing': 'Tilgjengelighetsinformasjon er ikke oppgitt.',
  'business.profile.photos': 'Bilder',
  'business.profile.noPhotos': 'Ingen flere bilder er lagt til.',
  'business.profile.openPhotoAria': 'Åpne {alt} i fullskjerm',
  'business.profile.mapMissing': 'Kartposisjon er ikke oppgitt.',
  'business.profile.postAs': 'Publiser som {name}',
  'business.profile.shareUpdate': 'Del en oppdatering på virksomhetsprofilen.',
  'business.profile.businessPost': 'Virksomhetsinnlegg',
  'business.profile.addPhotos': 'Legg til bilder',
  'business.profile.postsLoadError': 'Innleggene kunne ikke lastes.',
  'business.profile.postImageAlt': 'Innleggsbilde fra {name}',
  'business.profile.postPages': 'Sider med virksomhetsinnlegg',
  'business.profile.eventPeriod': 'Arrangementsperiode',
  'business.profile.upcoming': 'Kommende',
  'business.profile.pastEvents': 'Tidligere arrangementer',
  'business.profile.eventsLoadError': 'Arrangementene kunne ikke lastes.',
  'business.profile.noUpcomingEvents': 'Ingen kommende arrangementer.',
  'business.profile.noPastEvents': 'Ingen tidligere arrangementer.',
  'business.profile.recurring': 'Gjentakende',
  'business.profile.bookingLoadError': 'Bestillingen kunne ikke lastes.',
  'business.profile.signInToMessage': 'Logg inn med en personlig konto for å sende melding til virksomheten.',
  'business.profile.businessChatRestriction': 'Virksomhetsidentiteter kan ikke starte kundechatter. Bytt til en personlig konto for å fortsette.',
  'business.profile.conversationLoadError': 'Samtalen kunne ikke lastes.',
  'business.profile.chatRetention': 'Meldinger utløper etter 12 måneder uten aktivitet. Du varsles 30 dager før sletting.',
  'business.profile.you': 'Du',
  'business.profile.messagePlaceholder': 'Hva kan de hjelpe med?',
  'business.profile.attachmentHelp': 'Opptil 5 bilder eller PDF-er, 10 MB hver.',
  'business.profile.sendMessage': 'Send melding',
} satisfies { [K in keyof typeof businessEn]: string };
